// extracted by mini-css-extract-plugin
export default {"footer":"PKKUPEoesC49PK_KSUWN","compact":"nxAXXqI_bign4N_ReOII"};